import {
  ArticleCategory,
  CreateArticleCategoryInput,
  CreateKeyFieldInput,
  KeyField,
  UpdateArticleCategoryInput,
  UpdateKeyFieldInput,
} from "../../api/schema";
import {
  InputFormMode,
  Mutation,
  UpdateStateHelper,
  ValuesVariables,
} from "../../components/form/InputForm";
import { InputModal } from "../../components/form/InputModal";
import { UserLanguage } from "../../lang/lang";
import {
  CreateArticleCategoryResponse,
  CreateKeyFieldResponse,
  UpdateArticleCategoryResponse,
  UpdateKeyFieldResponse,
} from "./graphql";
import {
  CreateArticleCategoryModalKeys,
  CreateKeyFieldModalKeys,
  UpdateArticleCategoryModalKeys,
  UpdateKeyFieldModalKeys,
} from "./modals";
import "./style.css";

export const CreateArticleCategoryModal = (props: {
  bundle: {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    mutation: Mutation<
      CreateArticleCategoryResponse,
      ValuesVariables<CreateArticleCategoryInput>
    >;
  };
}) => (
  <InputModal<
    ArticleCategory,
    CreateArticleCategoryResponse,
    CreateArticleCategoryInput
  >
    keys={CreateArticleCategoryModalKeys}
    texts={UserLanguage().pages.articleCategory.actions}
    resetOnClose
    mode={InputFormMode.Create}
    className="article_category_dialog"
    {...props.bundle}
  />
);

export const UpdateArticleCategoryModal = (props: {
  bundle: {
    onClose: () => void;
    onSuccess: () => void;
    modalState: UpdateStateHelper<ArticleCategory>;
    mutation: Mutation<
      UpdateArticleCategoryResponse,
      ValuesVariables<UpdateArticleCategoryInput>
    >;
  };
}) => (
  <InputModal<
    ArticleCategory,
    UpdateArticleCategoryResponse,
    UpdateArticleCategoryInput
  >
    keys={UpdateArticleCategoryModalKeys}
    input={props.bundle.modalState.item}
    open={props.bundle.modalState.open}
    texts={UserLanguage().pages.articleCategory.actions}
    {...props.bundle}
    resetOnClose
    mode={InputFormMode.Edit}
    className="article_category_dialog"
  />
);

export const CreateKeyFieldModal = (props: {
  bundle: {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    mutation: Mutation<
      CreateKeyFieldResponse,
      ValuesVariables<CreateKeyFieldInput>
    >;
    articleCategory: ArticleCategory;
  };
}) => (
  <InputModal<KeyField, CreateKeyFieldResponse, CreateKeyFieldInput>
    keys={CreateKeyFieldModalKeys(props.bundle.articleCategory)}
    texts={UserLanguage().pages.keyField.actions}
    resetOnClose
    mode={InputFormMode.Create}
    className="article_category_dialog"
    reformId={["article_category"]}
    {...props.bundle}
  />
);

export const UpdateKeyFieldModal = (props: {
  bundle: {
    onClose: () => void;
    onSuccess: () => void;
    modalState: UpdateStateHelper<KeyField>;
    mutation: Mutation<
      UpdateKeyFieldResponse,
      ValuesVariables<UpdateKeyFieldInput>
    >;
    articleCategory: ArticleCategory;
  };
}) => (
  <InputModal<KeyField, UpdateKeyFieldResponse, UpdateKeyFieldInput>
    keys={UpdateKeyFieldModalKeys(props.bundle.articleCategory)}
    input={props.bundle.modalState.item}
    open={props.bundle.modalState.open}
    texts={UserLanguage().pages.keyField.actions}
    {...props.bundle}
    resetOnClose
    mode={InputFormMode.Edit}
    className="article_category_dialog"
    reformId={["article_category"]}
  />
);
